import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-fp-banner',
    templateUrl: './fp-banner.component.html',
    styleUrls: ['./fp-banner.component.scss']
})
export class FpBannerComponent {
    
}